import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    ...storeModuleFactory({
        name:               'billingAlertsTypes',
        endpoint:           endpoints.billingAlerts.endpointAlertsTypes,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: json => json
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/billingAlertsTypes.js